import ElementTable from './ElementTable.vue';

export { ElementTable };
